module.exports = __webpack_public_path__ + "img/logo.d817a190.png";